import { Box } from '@mui/material'
import { FC, PropsWithChildren } from 'react'
import { Sidebar } from './sidebar.tsx'

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Sidebar />
      {children}
    </Box>
  )
}
